import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'
export default css`
  &.DepartmentMembersTable {
    display: flex;
    flex-direction: column;
    gap: ${spacing(6)};
    width: 100%;
    height: 100%;
    overflow: auto;
    /* TODO: replace this with ext-ui breakpoints */
    ${getBreakpointDown(breakpointSizes.SM)(css`
      min-height: 90vh;
    `)};

    & .table-header {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: ${spacing(4)};
      padding: ${spacing(4)} ${spacing(6)};
      border-bottom: 1px solid ${base_colorContentBorder};

      & .toolbar-container {
        display: flex;
        align-items: center;
        gap: ${spacing(10)};

        /* TODO: remove once we add the search feature to teams */
        & .toolbar-filler {
          width: 100%;
        }
      }
    }
  }
`
